module.exports = __webpack_public_path__ + "media/images/ai_brain_topics/damaged_item-6c46ab673151d1959217449f2b38191c.png";